import { DisplayFeatureStatic } from '~shared/types/pricing/features';
import { SummaryFeatureRuleMap } from '~app/pages/Pricing/transformers/summary/types';
import { SETTING_UNLIMITED } from '~app/pages/Pricing/transformers/summary/rules/featureRules';
import { formatSummaryFeature } from '~app/pages/Pricing/lib/PackageFeatures';
import { Packages } from '~shared/constants/pricing';

const formsPackages = [Packages.FormsAnnual, Packages.FormsMonthly];
const formsAndEnhanced = [
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.FormsAnnual,
  Packages.FormsMonthly,
];

const Grow2529FeatureRules: SummaryFeatureRuleMap = {
  grow_2529_create_limit: ({ survey_create_limit, create_question_limit }) => {
    let obj: DisplayFeatureStatic = {};

    if (survey_create_limit?.setting === SETTING_UNLIMITED) {
      obj = formatSummaryFeature('grow_2529_survey_create_limit');
    } else if (create_question_limit?.setting === SETTING_UNLIMITED) {
      obj = formatSummaryFeature('create_question_limit');
    }

    return obj;
  },
  grow_2529_unlimited_questions: (_, { packageName }) => {
    if (formsPackages.includes(packageName as Packages)) {
      return formatSummaryFeature('grow_2529_forms_unlimited_questions');
    }
    return formatSummaryFeature('grow_2529_unlimited_questions');
  },
  grow_2529_question_types: (_, { packageName }) => {
    if (formsPackages.includes(packageName as Packages)) {
      return formatSummaryFeature('grow_2529_forms_question_types');
    }
    return formatSummaryFeature('grow_2529_question_types');
  },
  grow_2529_analysis_filter: (_, { packageName }) => {
    if (formsPackages.includes(packageName as Packages)) {
      return formatSummaryFeature('grow_2529_forms_analysis_filter');
    }
    return formatSummaryFeature('grow_2529_analysis_filter');
  },
  grow_2529_payment_qt: (_, { packageName, dataCenter }) => {
    return formsAndEnhanced.includes(packageName as Packages) && dataCenter !== 'EU'
      ? formatSummaryFeature('grow_2529_payment_qt')
      : null;
  },
  grow_2529_file_upload: (_, { packageName }) => {
    return formsAndEnhanced.includes(packageName as Packages) ? formatSummaryFeature('grow_2529_file_upload') : null;
  },

  grow_2529_website_embed: () => formatSummaryFeature('grow_2529_website_embed'),
  grow_2529_zapier_integrations: () => formatSummaryFeature('grow_2529_zapier_integrations'),
  grow_2529_survey_branding: () => formatSummaryFeature('grow_2529_survey_branding'),
  everything_in: (_, { packageName }) => formatSummaryFeature(`everything_in_${packageName}`),
  grow_2529_survey_quiz: () => formatSummaryFeature('grow_2529_survey_quiz'), // Survey & Quiz question types
  grow_2529_unlimited_analysis_filters: () => formatSummaryFeature('grow_2529_unlimited_analysis_filters'), // Unlimited analysis filters
  create_advanced_features: () => formatSummaryFeature('grow_2529_statistical_significance'),
};

export default Grow2529FeatureRules;
